export const isCollectionPage = (url) => {
    if (typeof url !== 'string') {
        return false;
    }
    return url.search('collection') !== -1;
};
